export class Appointment {
    ref_no: number;
    company_id: number;
    booked_on_date: Date;
    booked_at_time: String;
    visitor_name: String;
    visitor_company: String;
    address: String;
    visitor_mobile_no: String;
    country: String;
    state: String;
    city: String;
    pin: number;
    appointment_fixed_by: String;
    whomto_meet: String;
    department_id: number;
    appointment_type: String;
    purpose: String;
    schedule_date_from: Date;
    schedule_time_from: String;
    schedule_date_to: Date;
    schedule_time_to: String;
}
